import React from 'react';
import Canvas from './Canvas';
import Form from './Form';

class App extends React.Component {
    state = {
        nodes: [],
        arcs: [],
        pathStart: 1,
        pathEnd: 2,
        clickedNodes: {
            origin: undefined,
            target: undefined,
            lastOrigin: undefined
        },
        distance: undefined
    };

    handleClickedNodes = ({id, distance}) => {
        const origin = this.state.clickedNodes.origin;
        const target = this.state.clickedNodes.target;
        const lastOrigin = this.state.clickedNodes.lastOrigin;

        if(!origin) {
            this.setState({clickedNodes: {origin: id, lastOrigin: id, target: undefined}});
        } else if(origin && !target) {
            if(id === lastOrigin) {
                this.setState({clickedNodes: {...this.state.clickedNodes, origin: undefined, lastOrigin: undefined}});
            } else {
                this.setState({clickedNodes: { origin: undefined, target: undefined, lastOrigin: undefined}});
                // Add new arc;
                this.addNewArc([origin, id], distance === '' ? 0 : distance);
            }
        }
        

        // if(!origin) {
        //     this.setState({clickedNodes: {...this.state.clickedNodes, origin: id, lastOrigin: id}});
        // } else if(origin && !target) {
        //     if(id === lastOrigin) {
        //         this.setState({clickedNodes: {...this.state.clickedNodes, origin: undefined, lastOrigin: undefined}});
        //     } else {
        //         this.setState({clickedNodes: {...this.state.clickedNodes, target: id, lastTarget: id}});
        //     }
        // } else {
        //     if(id === lastOrigin) {
        //         this.setState({clickedNodes: {origin: target, lastOrigin: target, target: undefined, lastTarget: undefined}});
        //     }
        //     if(id === lastTarget) {
        //         this.setState({clickedNodes: {...this.state.clickedNodes, target: undefined, lastTarget: undefined}});
        //     }
        // }
    }

    // state = {
    //     nodes: [
    //         { id: 1, x: 550,y: 0 },
    //         { id: 2, x: 300, y: 100 },
    //         { id: 3, x: 850, y: 100 },
    //         { id: 4, x: 200, y: 300 },
    //         { id: 5, x: 1000, y: 300 },
    //         { id: 6, x: 300, y: 500 },
    //         { id: 7, x: 850, y: 500 },
    //         { id: 8, x: 600, y: 600 }
    //     ],

    //     arcs: [
    //         {id: 1, nodes: [4, 1]},
    //         {id: 2, nodes: [4, 2]},
    //         {id: 3, nodes: [4, 8]},
    //     ]
    // };

    addNewArc = (nodes, distance) => {
        const newArc = {
            id: this.state.arcs.length + 1,
            nodes: [nodes[0], nodes[1]],
            distance: parseInt(distance),
            type: undefined // undefined or 'sp'
        };

        this.setState(
            {
                arcs: [...this.state.arcs, newArc]
            }
        );
    };

    changeStartEnd = (pathStart, pathEnd) => {
        pathStart = parseInt(pathStart);
        pathEnd = parseInt(pathEnd);
        this.setState({pathStart, pathEnd})
    }

    generateNodes = (number) => {
        if(number > this.state.nodes.length) {
            const nodes = [];
            for(var i = 0; i < number; i++) {
                const node = {
                    id: i+1,
                    x: 450*Math.cos((Math.PI * 2/ number)*(i)) + 450 + 100, // 600*Math.cos(Math.PI/(i+2)) + 600
                    y: 250*Math.sin((Math.PI * 2/ number)*(i)) + 250 + 100
                };

                nodes.push(node);
            }

            this.setState({nodes});
        }
    }

    bellman = (listnodes,listarcs,source,destination) => {

        var nouveauDistance=new Array(listnodes.length); /* Tableau des distance calculer */
        var precedantDistance=new Array(listnodes.length); /* Tableau de distance pour stocker les valeurs des distances precedents */
        var listePrecedents;/* liste des precedents d'un noeud */
        var minPrecedentDistance;/* variable pour stocker la distance minimal entre un noeud et ses precedents*/
        var stable;/* Variable pour point d'arrêt */
        var listSrouceDest=new Array(listnodes.length);
        var listSourceDestPrecedent = new Array(listnodes.length);
        var listResultat=new Array(listnodes.length);
        var resultat;
        /* Initialisation des distance */
        for(var i=0;i<listnodes.length;i++){
            if(listnodes[i]!=source){
            nouveauDistance[i]=Number.MAX_SAFE_INTEGER;
            precedantDistance[i]=Number.MAX_SAFE_INTEGER;
            }
            
        }
        nouveauDistance[listnodes.indexOf(source)]=0;
        precedantDistance[listnodes.indexOf(source)]=0;
        do{
            for(var i=0;i<listnodes.length;i++){
                listePrecedents=new Array(listnodes.length);
                var iteration=0;
                /*Pour tous les noeuds different du source */
            if(listnodes[i]!=source){
                    /* Boucle pour la determination des precedents*/
                for(var j=0;j<listarcs.length;j++){
                        if(listarcs[j].nodes[1]==listnodes[i]){
                            listePrecedents[iteration]=listarcs[j].nodes[0];
                            iteration++;
                        }
                    }
                /* Si le noeud disposes des precedents */
                if(listePrecedents[0]!=undefined){
                    /* initialisation minPrecedentsdistance */
                    var tab=[listePrecedents[0],listnodes[i]];
                        var dist=listarcs.filter(function (element){
                            return JSON.stringify(element.nodes)==JSON.stringify(tab);
                        })[0].distance;
                        if(dist!=undefined){
                            minPrecedentDistance=nouveauDistance[listnodes.indexOf(listePrecedents[0])]+dist;
                        }
                        /*La determination de la plus petite valeur des distance entre un noeud et ses précedents */
                    for(var k=0;k<listePrecedents.length;k++){
                            if(listePrecedents[k]!=undefined){
                                var tab=[listePrecedents[k],listnodes[i]];
                                var dist=listarcs.filter(function (element){
                                    return JSON.stringify(element.nodes)==JSON.stringify(tab);
                                })[0].distance;
                                if(minPrecedentDistance>=nouveauDistance[listnodes.indexOf(listePrecedents[k])]+dist){
                                    var tmp=minPrecedentDistance;
                                    minPrecedentDistance=nouveauDistance[listnodes.indexOf(listePrecedents[k])]+dist;
                                    if((tmp==nouveauDistance[listnodes.indexOf(listePrecedents[k])]+dist) && listSrouceDest[i]!=undefined && listSrouceDest[i].source==source){
                                        listSrouceDest[i]={
                                            source:source,
                                            destination:i,
                                        }
    
                                    }else{
                                        listSrouceDest[i]={
                                            source:listePrecedents[k],
                                            destination:i,
                                        }
                                    }

                                }
                            }
                        }
                        /* Affectation de la nouvelle distance */
                    if(nouveauDistance[i]>minPrecedentDistance){
                            nouveauDistance[i]=minPrecedentDistance;
                        }
                    }
                    
                }
            }
        listSrouceDest[listnodes.indexOf(source)]={
            source:source,
            destination:source,
        }
        stable=-1;
        for(var i=0;i<precedantDistance.length;i++){
                if(precedantDistance[i]!=nouveauDistance[i]){
                    stable++;
                    precedantDistance[i]=nouveauDistance[i];
                }
        }
        }while(stable!=-1);
        for(var i=0;i<listResultat.length;i++){
            listResultat[i]={
                longueur:nouveauDistance[i],
                chemin:[i],
            }
        }
        for(var i=0;i<listSrouceDest.length;i++){
            if(listSrouceDest[i]!=undefined){
                listSourceDestPrecedent[i]={
                    source:listSrouceDest[i].source,
                    destination:listSrouceDest[i].destination,
                }
            }
        }

        for(var i=0;i<listResultat.length;i++){
        if(listSrouceDest[i]!=undefined){
            if(listSrouceDest[i].destination!=source){
                while(listSrouceDest[i].source!=source){
                    listResultat[i].chemin.unshift(listSrouceDest[i].source);
                    listSrouceDest[i].source=listSourceDestPrecedent[listnodes.indexOf(listSrouceDest[i].source)].source;
                }
                listResultat[i].chemin.unshift(listSrouceDest[i].source);
            }
        }
        }
        console.log("Ok ");
        resultat=new Array(listResultat[listnodes.indexOf(destination)].chemin.length-1);
        for(var i=0;i<resultat.length;i++){
            var tab=[listResultat[listnodes.indexOf(destination)].chemin[i],listResultat[listnodes.indexOf(destination)].chemin[i+1]];
            resultat[i]=listarcs.filter(function (element){
                return JSON.stringify(element.nodes)==JSON.stringify(tab);
            })[0].id;
        }
        return resultat;


        // var nouveauDistance=new Array(listnodes.length); /* Tableau des distance calculer */
        // var precedantDistance=new Array(listnodes.length); /* Tableau de distance pour stocker les valeurs des distances precedents */
        // var listePrecedents;/* liste des precedents d'un noeud */
        // var minPrecedentDistance;/* variable pour stocker la distance minimal entre un noeud et ses precedents*/
        // var stable;/* Variable pour point d'arrêt */
        // var listSrouceDest=new Array(listnodes.length);
        // var listSourceDestPrecedent = new Array(listnodes.length);
        // var listResultat=new Array(listnodes.length);
        // var resultat;
        // /* Initialisation des distance */
        // for(var i=0;i<listnodes.length;i++){
        //     if(listnodes[i] !== source){
        //     nouveauDistance[i]=Number.MAX_SAFE_INTEGER;
        //     precedantDistance[i]=Number.MAX_SAFE_INTEGER;
        //     }
            
        // }
        // nouveauDistance[listnodes.indexOf(source)]=0;
        // precedantDistance[listnodes.indexOf(source)]=0;

        // do{
        //     for(i=0;i<listnodes.length;i++){
        //         listePrecedents=new Array(listnodes.length);
        //         var iteration=0;
        //         /*Pour tous les noeuds different du source */
        //         if(listnodes[i] !== source){
        //             /* Boucle pour la determination des precedents*/
        //             for(var j=0;j<listarcs.length;j++){
        //                 if(listarcs[j].nodes[1] === listnodes[i]){
        //                     listePrecedents[iteration]=listarcs[j].nodes[0];
        //                     iteration++;
        //                 }
        //             }
        //         /* Si le noeud disposes des precedents */
        //         if(listePrecedents[0] !== undefined){
        //             /* initialisation minPrecedentsdistance */
        //                 var tab=[listePrecedents[0],listnodes[i]];
        //                 var dist=listarcs.filter(function (element){
        //                     return JSON.stringify(element.nodes)==JSON.stringify(tab);
        //                 })[0].distance;
        //                 if(dist!=undefined){
        //                     minPrecedentDistance=nouveauDistance[listnodes.indexOf(listePrecedents[0])]+dist;
        //                 }
        //                 /* La determination de la plus petite valeur des distance entre un noeud et ses précedents */
        //             for(var k=0;k<listePrecedents.length;k++){
        //                     if(listePrecedents[k]!=undefined){
        //                         var tab=[listePrecedents[k],listnodes[i]];
        //                         var dist=listarcs.filter(function (element){
        //                             return JSON.stringify(element.nodes)==JSON.stringify(tab);
        //                         })[0].distance;
        //                         if(minPrecedentDistance>=nouveauDistance[listnodes.indexOf(listePrecedents[k])]+dist){
        //                             var tmp=minPrecedentDistance;
        //                             minPrecedentDistance=nouveauDistance[listnodes.indexOf(listePrecedents[k])]+dist;
        //                             if((tmp==nouveauDistance[listnodes.indexOf(listePrecedents[k])]+dist) && listSrouceDest[i]!=undefined && listSrouceDest[i].source==source){
        //                                 listSrouceDest[i]={
        //                                     source:source,
        //                                     destination:i,
        //                                 }
    
        //                             }else{
        //                                 listSrouceDest[i]={
        //                                     source:listePrecedents[k],
        //                                     destination:i,
        //                                 }
        //                             }

        //                         }
        //                     }
        //                 }
        //                 /* Affectation de la nouvelle distance */
        //                 if(nouveauDistance[i]>minPrecedentDistance){
        //                     nouveauDistance[i]=minPrecedentDistance;
        //                 }
        //             }
                    
        //         }
        //     }
        // listSrouceDest[listnodes.indexOf(source)]={
        //     source:source,
        //     destination:source,
        // }
        // stable=-1;
        // for(var i=0;i<precedantDistance.length;i++){
        //         if(precedantDistance[i]!=nouveauDistance[i]){
        //             stable++;
        //             precedantDistance[i]=nouveauDistance[i];
        //         }
        //     }
        // }while(stable!=-1);
        // for(var i=0;i<listResultat.length;i++){
        //     listResultat[i]={
        //         longueur:nouveauDistance[i],
        //         chemin:[i],
        //     }
        // }
        // for(var i=0;i<listSrouceDest.length;i++){
        //     listSourceDestPrecedent[i]={
        //         source:listSrouceDest[i].source,
        //         destination:listSrouceDest[i].destination,
        //     }
        // }

        // for(var i=0;i<listResultat.length;i++){
        //     if(listSrouceDest[i].destination!=source){
        //         while(listSrouceDest[i].source!=source){
        //             listResultat[i].chemin.unshift(listSrouceDest[i].source);
        //             listSrouceDest[i].source=listSourceDestPrecedent[listnodes.indexOf(listSrouceDest[i].source)].source;
        //         }
        //         listResultat[i].chemin.unshift(listSrouceDest[i].source);
        //     }
        // }
        // resultat=new Array(listResultat[listnodes.indexOf(destination)].chemin.length-1);

        // for(var i=0;i<listResultat[listnodes.indexOf(destination)].chemin.length-1;i++){
        //     var tab=[listResultat[listnodes.indexOf(destination)].chemin[i],listResultat[listnodes.indexOf(destination)].chemin[i+1]];
        //     resultat[i]=listarcs.filter(function (element){
        //         return JSON.stringify(element.nodes) === JSON.stringify(tab);
        //     })[0].id;
        // }

        // return resultat;

    }

    algorithme = () => {
        // reset arcs
        const oldArcs = this.state.arcs.map((arc) => {
            return {...arc, type: undefined};
        });

        const nodes = [];
        for(var i = 0; i < this.state.nodes.length; i++) {
            nodes.push(i);
        }
        const arcs = oldArcs.map(({id, distance, nodes}) => {
            return {
                id: id - 1,
                distance,
                nodes: [nodes[0] - 1, nodes[1] - 1]
            }
        });

        const pathStart = this.state.pathStart - 1;
        const pathEnd = this.state.pathEnd - 1;

        console.log('nodes: ');
        console.log(nodes);
        console.log('arcs: ');
        console.log(arcs);
        console.log('pathStart: ' + pathStart);
        console.log('pathEnd: ' + pathEnd);

        const arcsShortestPath = this.bellman(nodes, arcs, pathStart, pathEnd);
        
        const arcsShortestPathReal = oldArcs.map((arc) => {
            if(arcsShortestPath.includes(arc.id - 1)) {
                return {
                    id: arc.id,
                    nodes: arc.nodes,
                    type: 'sp',
                    distance: arc.distance
                }
            }

            return arc;
        });

        console.log(arcsShortestPath);
        console.log(arcsShortestPathReal);

        // calcul de la distance
        let distance = 0;
        arcsShortestPathReal.forEach(arc => {
            if(arc.type) {
                distance += arc.distance;
            }
        });

        this.setState({arcs: arcsShortestPathReal, distance});
    }

    render() {
        return (
            <div>
                <div className="header-container">
                    <h1 className="container">Plus court chemin app</h1>
                </div>
                <Form
                    generateNodes={this.generateNodes} 
                    addNewArc={this.addNewArc} 
                    nodecount={this.state.nodes.length}
                    changeStartEnd={this.changeStartEnd}    
                    algorithme={this.algorithme}
                />
                <Canvas 
                    {...this.state} 
                    handleClickedNodes={this.handleClickedNodes} 
                    clickedNode={this.state.clickedNodes.origin}  
                />
            </div>
        )
    }
}
export default App;